/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const LightBulbFilled = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M12.2 16.3C16.066 16.3 19.2 13.166 19.2 9.29999C19.2 5.43399 16.066 2.29999 12.2 2.29999C8.33402 2.29999 5.20001 5.43399 5.20001 9.29999C5.20001 13.166 8.33402 16.3 12.2 16.3Z"
                        fill={color}
                    />
                    <path d="M15.6 15.4H8.70001V18.8H15.6V15.4Z" fill={color} />
                    <path
                        d="M8.80001 8.99999C8.80001 7.19999 10.3 5.79999 12 5.79999V4.29999C9.40001 4.29999 7.20001 6.39999 7.20001 9.09999H8.70001L8.80001 8.99999Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9 20C8.2 20 7.5 19.3 7.5 18.5V15.6C5.4 14.2 4 11.7 4 9C4 4.6 7.6 1 12 1C16.4 1 20 4.6 20 9C20 13.4 18.6 14.2 16.5 15.6V18.5C16.5 19.3 15.8 20 15 20H9ZM15 15.7C15 15.1 15.3 14.6 15.8 14.3C17.4 13.1 18.5 11.2 18.5 9C18.5 5.4 15.6 2.5 12 2.5C8.4 2.5 5.5 5.4 5.5 9C5.5 12.6 6.6 13.1 8.2 14.3C8.7 14.6 9 15.1 9 15.7V18.5H15V15.7Z"
                        fill={color}
                    />
                    <path d="M15 21.5V23H9V21.5H15Z" fill={color} />
                </svg>
        );
    };
